let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1dl4M")).then(() => parcelRequire('dx7Jv'));